module.exports = __webpack_public_path__ + "static/2-b0fc92a592d9ccf35af824e95cb67a68.png";